import { useEffect, useState } from 'react';

const CACHE_KEY = 'dailyQuoteText_kr_v1';
const FALLBACK = '집중하고 꾸준히 나아가자.';

const localDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

/** 오늘의 한마디 (날짜별 캐시). 실패하면 기본 문구를 보여주고 다음 방문에 다시 시도한다. */
export const useDailyQuote = (): string => {
    const [quote, setQuote] = useState(FALLBACK);

    useEffect(() => {
        const today = localDate();
        try {
            const cached = JSON.parse(localStorage.getItem(CACHE_KEY) ?? 'null');
            if (cached?.date === today && cached.text) {
                setQuote(cached.text);
                return;
            }
        } catch (_) { }

        const controller = new AbortController();
        fetch('https://korean-advice-open-api.vercel.app/api/advice', { signal: controller.signal })
            .then((res) => {
                if (!res.ok) throw new Error('fetch failed');
                return res.json();
            })
            .then((data) => {
                if (!data?.message) return;
                setQuote(data.message);
                localStorage.setItem(CACHE_KEY, JSON.stringify({ date: today, text: data.message }));
            })
            .catch(() => { });

        return () => controller.abort();
    }, []);

    return quote;
};
